import { createSlice } from "@reduxjs/toolkit";

const MAX_ITEMS = 30;

const liveNotificationsSlice = createSlice({
  name: "liveNotifications",
  initialState: {
    items: [],
    unreadCount: 0,
  },
  reducers: {
    notificationReceived: (state, action) => {
      state.items.unshift(action.payload);
      if (state.items.length > MAX_ITEMS) {
        state.items.length = MAX_ITEMS;
      }
      state.unreadCount += 1;
    },
    markAllRead: (state) => {
      state.unreadCount = 0;
    },
    clearNotifications: (state) => {
      state.items = [];
      state.unreadCount = 0;
    },
  },
});

export const { notificationReceived, markAllRead, clearNotifications } =
  liveNotificationsSlice.actions;

export default liveNotificationsSlice.reducer;
